export default "__VITE_ASSET__de6689a5__"